import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";

export const WidgetContext = React.createContext();

export const WidgetProvider = (props) => {
  // Show Tooltips
  const [showTooltips, setShowTooltips] = useState(true);

  // Navigation Menu
  const [navigationExpanded, setNavigationExpanded] = useState(true);
  const widgetArea = useRef(null);

  // Intro Dialog
  const [displayIntro, setDisplayIntro] = useState(
    !props.inline ? true : false
  );

  // Data filter values
  const [starterCounter, setStarterCounter] = useState(1);
  const [cycleCounter, setCycleCounter] = useState(30);
  const [efficiencyCounter, setEfficiencyCounter] = useState(100);

  // The user defined stopping point for the cycle sequence
  const [cycleCounterStop, setCycleCounterStop] = useState(30);
  useEffect(() => {
    setCycleCounter(cycleCounterStop);
  }, [cycleCounterStop]);

  // Chart toggles
  const [fluidXAxis, setFluidXAxis] = useState(false);
  const [fluidYAxis, setFluidYAxis] = useState(false);

  // Line chart display
  const [totalDNAline, setTotalDNAline] = useState(true);
  const [desiredRegionLine, setDesiredRegionLine] = useState(true);
  const [overhangLine, setOverhangLine] = useState(true);

  // Widget Data
  const [widgetData, setWidgetData] = useState(props.widgetData);
  useEffect(() => {
    // Filter Data based on UI changes
    setWidgetData(
      props.widgetData.filter(
        (data) =>
          data.startercounter == starterCounter &&
          data.cyclecounter < cycleCounter + 1 &&
          data.efficiencycounter == efficiencyCounter
      )
    );
  }, [starterCounter, cycleCounter, efficiencyCounter]);

  const [totalData, setTotalData] = useState(() => {
    const totalData = [];
    widgetData.map((dataInstance) => {
      totalData.push({
        x: dataInstance.cyclecounter,
        y: dataInstance.totalcounter,
      });
    });
    return totalData;
  });
  const [desiredData, setDesiredData] = useState(() => {
    const desiredData = [];
    widgetData.map((dataInstance) => {
      desiredData.push({
        x: dataInstance.cyclecounter,
        y: dataInstance.desiredcounter,
      });
    });
    return desiredData;
  });
  const [overhangData, setOverhangData] = useState(() => {
    const overhangData = [];
    widgetData.map((dataInstance) => {
      overhangData.push({
        x: dataInstance.cyclecounter,
        y: dataInstance.overhangcounter,
      });
    });
    return desiredData;
  });

  useEffect(() => {
    const totalData = [];
    const desiredData = [];
    const overhangData = [];

    widgetData.map((dataInstance) => {
      totalData.push({
        x: dataInstance.cyclecounter,
        y: dataInstance.totalcounter,
      });
      desiredData.push({
        x: dataInstance.cyclecounter,
        y: dataInstance.desiredcounter,
      });
      overhangData.push({
        x: dataInstance.cyclecounter,
        y: dataInstance.overhangcounter,
      });
    });

    setTotalData(totalData);
    setDesiredData(desiredData);
    setOverhangData(overhangData);
  }, [widgetData]);

  const [countPlaying, setCountPlaying] = useState(false);
  useEffect(() => {
    if (countPlaying && cycleCounter >= cycleCounterStop) {
      setCountPlaying(false);
    } else if (countPlaying) {
      window.setTimeout(() => {
        setCycleCounter(cycleCounter + 1);
      }, 100);
    }
  }, [countPlaying, cycleCounter]);

  const playCount = () => {
    if (!countPlaying) {
      setCycleCounter(1);
      setCountPlaying(true);
    } else {
      setCountPlaying(false);
    }
  };

  return (
    <WidgetContext.Provider
      value={{
        playCount,
        showTooltips,
        setShowTooltips,
        countPlaying,
        setCountPlaying,
        navigationExpanded,
        setNavigationExpanded,
        displayIntro,
        setDisplayIntro,
        starterCounter,
        setStarterCounter,
        efficiencyCounter,
        setEfficiencyCounter,
        cycleCounter,
        setCycleCounter,
        cycleCounterStop,
        setCycleCounterStop,
        fluidXAxis,
        setFluidXAxis,
        fluidYAxis,
        setFluidYAxis,
        totalDNAline,
        setTotalDNAline,
        desiredRegionLine,
        setDesiredRegionLine,
        overhangLine,
        setOverhangLine,
        widgetData,
        setWidgetData,
        totalData,
        setTotalData,
        desiredData,
        setDesiredData,
        overhangData,
        setOverhangData,
        widgetArea,
      }}
    >
      {props.children}
    </WidgetContext.Provider>
  );
};

WidgetProvider.PropTypes = {
  widgetData: PropTypes.widgetData,
  inline: PropTypes.boolean,
};
